module.exports = __webpack_public_path__ + "static/media/logo.e3bff355.png";